import {
  ACTION_EDIT_SITE_FOOTER_LINK__FAIL,
  ACTION_EDIT_SITE_FOOTER_LINK__REQUEST,
  ACTION_EDIT_SITE_FOOTER_LINK__SUCCESS,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_SITE_FOOTER_LINK__REQUEST:
    case ACTION_EDIT_SITE_FOOTER_LINK__SUCCESS:
      return null;

    case ACTION_EDIT_SITE_FOOTER_LINK__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
